"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PresenceManager = exports.PresenceEvent = void 0;
const fanout_1 = require("thingies/lib/fanout");
const constants_1 = require("./constants");
class PresenceEvent {
    constructor(added, updated, removed) {
        this.added = added;
        this.updated = updated;
        this.removed = removed;
    }
}
exports.PresenceEvent = PresenceEvent;
/**
 * Reactive in-memory presence store. Tracks remote peer states keyed by
 * `processId`. LWW by `seq` — stale updates are silently ignored. No internal
 * timers; the caller controls GC via {@link removeOutdated}.
 */
class PresenceManager {
    constructor(timeout = 30000) {
        this.timeout = timeout;
        this.peers = {};
        this.onChange = new fanout_1.FanOut();
        this.local = ['', Math.random().toString(36).slice(2), 0, Math.floor(Date.now() / 1000), [], {}];
    }
    // ---------------------------------------------------------- remote presence
    /** LWW by `seq` per `processId` — stale updates are silently ignored. */
    receive(incoming) {
        const processId = incoming[constants_1.UserPresenceIdx.ProcessId];
        const incomingSeq = incoming[constants_1.UserPresenceIdx.Seq];
        const existing = this.peers[processId];
        if (existing && existing[0][constants_1.UserPresenceIdx.Seq] >= incomingSeq)
            return;
        this.peers[processId] = [incoming, Date.now()];
        this.onChange.emit(new PresenceEvent(existing ? [] : [processId], existing ? [processId] : [], []));
    }
    get(processId) {
        return this.peers[processId]?.[0];
    }
    size() {
        return Object.keys(this.peers).length;
    }
    /** Remove peers whose `receivedAt` exceeds `timeout`. */
    removeOutdated(timeout = this.timeout) {
        const now = Date.now();
        const removed = [];
        const peers = this.peers;
        for (const processId in peers) {
            if (now - peers[processId][1] > timeout) {
                delete peers[processId];
                removed.push(processId);
            }
        }
        if (removed.length)
            this.onChange.emit(new PresenceEvent([], [], removed));
        return removed;
    }
    merge(snapshot) {
        for (const incoming of snapshot)
            this.receive(incoming);
    }
    remove(processId) {
        if (!(processId in this.peers))
            return false;
        delete this.peers[processId];
        this.onChange.emit(new PresenceEvent([], [], [processId]));
        return true;
    }
    destroy() {
        const removed = Object.keys(this.peers);
        this.peers = {};
        if (removed.length)
            this.onChange.emit(new PresenceEvent([], [], removed));
    }
    // ----------------------------------------------------------- local presence
    setUserId(userId) {
        this.local[constants_1.UserPresenceIdx.UserId] = userId;
    }
    getUserId() {
        return this.local[constants_1.UserPresenceIdx.UserId];
    }
    setProcessId(processId) {
        this.local[constants_1.UserPresenceIdx.ProcessId] = processId;
    }
    getProcessId() {
        return this.local[constants_1.UserPresenceIdx.ProcessId];
    }
    setMeta(meta) {
        this.local[constants_1.UserPresenceIdx.Meta] = meta;
    }
    getMeta() {
        return this.local[constants_1.UserPresenceIdx.Meta];
    }
    setSelections(selections) {
        this.local[constants_1.UserPresenceIdx.Seq]++;
        this.local[constants_1.UserPresenceIdx.Ts] = Math.floor(Date.now() / 1000);
        this.local[constants_1.UserPresenceIdx.Selections] = selections;
    }
    getSelections() {
        return this.local[constants_1.UserPresenceIdx.Selections] || [];
    }
    clearSelections() {
        this.setSelections([]);
    }
}
exports.PresenceManager = PresenceManager;
